import React from "react";
import { CircleNotch } from "@phosphor-icons/react";

export function LoadingState({ message = "Loading data..." }) {
    return (
        <div className="flex flex-col items-center justify-center py-16 animate-fade-up">
            <div className="relative">
                <CircleNotch size={40} className="text-brand-action animate-spin" weight="bold" />
            </div>
            <p className="mt-4 text-brand-inkSoft text-sm">{message}</p>
        </div>
    );
}

export function TableLoadingSkeleton({ rows = 5, cols = 6 }) {
    return (
        <div className="bg-white border border-brand-line rounded-sm overflow-hidden">
            <div className="animate-pulse">
                {/* Header */}
                <div className="bg-brand-bg border-b border-brand-line py-3 px-4">
                    <div className="flex gap-4">
                        {Array.from({ length: cols }).map((_, i) => (
                            <div key={i} className="h-3 bg-brand-line rounded flex-1"></div>
                        ))}
                    </div>
                </div>
                {/* Rows */}
                {Array.from({ length: rows }).map((_, i) => (
                    <div key={i} className="border-b border-brand-line py-3 px-4">
                        <div className="flex gap-4">
                            {Array.from({ length: cols }).map((_, j) => (
                                <div key={j} className="h-4 bg-brand-bg rounded flex-1"></div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export function CardLoadingSkeleton({ count = 6 }) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="bg-white border border-brand-line rounded-sm p-6 animate-pulse">
                    <div className="h-8 bg-brand-bg rounded w-3/4 mb-3"></div>
                    <div className="h-4 bg-brand-bg rounded w-1/2 mb-4"></div>
                    <div className="space-y-2">
                        <div className="h-3 bg-brand-bg rounded"></div>
                        <div className="h-3 bg-brand-bg rounded w-5/6"></div>
                    </div>
                </div>
            ))}
        </div>
    );
}
